var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFollowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Follow-up",
    clipPath: "url(#clip0_1232_23747)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow_right_up_circle_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99967 14.6654C11.6817 14.6654 14.6663 11.6807 14.6663 7.9987C14.6663 4.3167 11.6817 1.33203 7.99967 1.33203C4.31767 1.33203 1.33301 4.3167 1.33301 7.9987C1.33301 11.6807 4.31767 14.6654 7.99967 14.6654ZM6.00167 5.9967C6.00167 6.17351 6.07191 6.34308 6.19694 6.4681C6.32196 6.59313 6.49153 6.66336 6.66834 6.66336H8.39234L5.52834 9.52736C5.46467 9.58886 5.41388 9.66243 5.37894 9.74376C5.344 9.8251 5.32561 9.91258 5.32484 10.0011C5.32407 10.0896 5.34094 10.1774 5.37446 10.2593C5.40798 10.3413 5.45748 10.4157 5.52008 10.4783C5.58267 10.5409 5.65711 10.5904 5.73904 10.6239C5.82097 10.6574 5.90876 10.6743 5.99727 10.6735C6.08579 10.6728 6.17327 10.6544 6.25461 10.6194C6.33595 10.5845 6.40951 10.5337 6.47101 10.47L9.33501 7.60603V9.33003C9.33501 9.50684 9.40525 9.67641 9.53027 9.80143C9.65529 9.92646 9.82486 9.9967 10.0017 9.9967C10.1785 9.9967 10.3481 9.92646 10.4731 9.80143C10.5981 9.67641 10.6683 9.50684 10.6683 9.33003V5.9967C10.6683 5.81989 10.5981 5.65032 10.4731 5.52529C10.3481 5.40027 10.1785 5.33003 10.0017 5.33003H6.66834C6.49153 5.33003 6.32196 5.40027 6.19694 5.52529C6.07191 5.65032 6.00167 5.81989 6.00167 5.9967Z",
    fill: "#97C9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1232_23747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowUp);
export default __webpack_public_path__ + "static/media/follow-up.63c95b1e8eb74e53ad08727fca6bc433.svg";
export { ForwardRef as ReactComponent };